import { render, staticRenderFns } from "./InboundSMSList.vue?vue&type=template&id=fc52b7be&scoped=true&"
import script from "./InboundSMSList.vue?vue&type=script&lang=js&"
export * from "./InboundSMSList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc52b7be",
  null
  
)

export default component.exports